<template>
<!--  <md-field :class="['md-datepicker', { 'md-native': !this.mdOverrideNative },this.isEditFlg ? 'valid': '']" md-clearable>-->
    <md-field :class="['md-datepicker', { 'md-native': !this.mdOverrideNative },this.isEditFlg ? 'valid': '']">
<!--    <md-date-icon class="md-date-icon" @click.native="toggleDialog" />-->
    <gd-calendar-icon class="md-date-icon" @click.native="toggleDialog" />
    <md-input
            :type="type"
            ref="input"
            v-model="inputDate"
            @input="onValueChange"
            @focus.native="onFocus"
            :pattern="pattern"
            :name="attrName"
            :placeholder="attrPlaceholder"
            :readonly="attrReadonly"
            :disabled="attrDisabled"
            :required="attrRequired"
            class="w-100"
            :class="inputClass"
    />

    <slot />

    <keep-alive>
      <md-datepicker-dialog
        v-if="showDialog"
        :md-date.sync="localDate"
        :md-disabled-dates="mdDisabledDates"
        :mdImmediately="mdImmediately"
        :work-mode="workMode"
        :display-cancel-btn="displayCancelBtn"
        :display-clear-btn="displayClearBtn"
        :dialog-class="dialogClass"
        @md-closed="toggleDialog"
      />
    </keep-alive>

    <md-overlay class="md-datepicker-overlay" md-fixed :md-active="showDialog" @click="toggleDialog" />
  </md-field>
</template>

<script>
  import Vue from 'vue'
  import isFirefox from 'is-firefox'
  import format from 'date-fns/format'
  import parse from 'date-fns/parse'
  import isValid from 'date-fns/isValid'
  import getYear from 'date-fns/getYear'
  import MdPropValidator from '../../core/utils/MdPropValidator'
  import MdOverlay from '../MdOverlay/MdOverlay'
  import MdDatepickerDialog from './MdDatepickerDialog'
  import MdDateIcon from '../../core/icons/MdDateIcon'
  import MdDebounce from '../../core/utils/MdDebounce'
  import MdField from '../MdField/MdField'
  import MdInput from '../MdField/MdInput/MdInput'
  import deflocale from './locale';
  import moment from 'moment';
  import GdCalendarIcon from "../../custom/Common/icons/GdCalendarIcon";
  import GdAddItemIcon from "../../custom/Common/icons/GdAddItemIcon";

  export default {
    name: 'MdDatepicker',
    components: {
        GdAddItemIcon,
      MdOverlay,
      MdDateIcon,
      MdField,
      MdInput,
      MdDatepickerDialog,
      GdCalendarIcon,

    },
    props: {
      value: [String, Number, Date],
      mdDisabledDates: [Array, Function],
      mdOpenOnFocus: {
        type: Boolean,
        default: true
      },
      mdOverrideNative: {
        type: Boolean,
        default: true
      },
      mdImmediately: {
        type: Boolean,
        default: true
      },
      mdModelType: {
        type: Function,
        default: Date,
        ...MdPropValidator('md-model-type', [Date, String, Number])
      },
      MdDebounce: {
        type: Number,
        default: 1000
      },
      inputClass:{
        type: Array,
        default: () => ([]),
      },
      dialogClass:{
        type: Array,
        default: () => ([]),
      },
      attrName: {
        type: String,
      },
      attrPlaceholder: {
        type: String,
      },
      attrReadonly: {
        type: Boolean,
        default: false,
      },
      attrDisabled: {
        type: Boolean,
        default: false,
      },
      attrRequired: {
        type: Boolean,
        default: false,
      },
      calendarDisabled: {
        type: Boolean,
        default: false,
      },
      workMode: {
        type: String,
        default: 'YMD',
      },
      displayCancelBtn: {
        type: Boolean,
        default: true
      },
      displayClearBtn: {
        type: Boolean,
        default: true
      },
    },
    data () {
      return {
        valueData: this.value,
        isEditFlg: false,
        isFirstRun: true,
        showDialog: false,
        // String for input
        inputDate: '',
        // Date for real value
        localDate: null,
        locale: deflocale,
      }
    },
    computed: {
      locales () {
        return this.locale;
      },
      type () {
        return this.mdOverrideNative
          ? 'text'
          : 'date';
      },
      dateFormat () {
        if (this.workMode === 'YM') {
          return (this.locale.formatYM || 'yyyy-MM');
        } else if (this.workMode === 'Y') {
          return (this.locale.formatY || 'yyyy');
        } else {
          return (this.locale.formatYMD || 'yyyy-MM-dd');
        }
      },
      modelType () {
        if (this.isModelTypeString) {
          return String;
        } else if (this.isModelTypeNumber) {
          return Number;
        } else if (this.isModelTypeDate) {
          return Date;
        } else {
          return this.mdModelType;
        }
      },
      isModelNull () {
        return this.value === null || this.value === undefined;
      },
      isModelTypeString () {
        return typeof this.value === 'string';
      },
      isModelTypeNumber () {
        return Number.isInteger(Object(this.value)) && this.value >= 0;
      },
      isModelTypeDate () {
        return typeof this.value === 'object' && this.value instanceof Date && isValid(this.value);
      },
      localString () {
        return this.localDate && format(this.localDate, this.dateFormat);
      },
      localNumber () {
        return this.localDate && Number(this.localDate);
      },
      parsedInputDate () {
        // this.log("Before InputDate = "+ this.inputDate);
        if(this.inputDate && this.inputDate.length > 0 && this.inputDate.length < 5 && this.workMode !== 'Y') {
          let numOnly = this.inputDate.replace(/[^0-9^\.]/g,"");
          let formatStr = "";
          formatStr = getYear(new Date());
          if(numOnly.slice(0,2)>12){
            numOnly = '0' + numOnly;
          }
          formatStr = formatStr+ "-"+numOnly.slice(0,2);
          // this.log("formatStr2 = " + formatStr);
          if(numOnly.length>2){
            formatStr = formatStr+ "-"+numOnly.slice(2,4);
            // this.log("formatStr2 = " + formatStr);
          }
          // this.log("formatStr = " + formatStr);
          let mm = moment(formatStr);
          if (mm.isValid()) {
            let d1 = null;
            if (this.workMode === 'YM') {
              d1 = mm.format('YYYY-MM');
            } else if (this.workMode === 'Y') {
              d1 = mm.format('YYYY');
            } else {
              d1 = mm.format('YYYY-MM-DD');
            }
            // this.log("d1 = " + d1);
            this.inputDate = d1;
          }
        }else if(this.inputDate && this.inputDate.length > 4 && this.workMode !== 'Y'){
          let numOnly = this.inputDate.replace(/[^0-9^\.]/g,"");
          let formatStr = "";
          formatStr=numOnly.slice(0,4)+ "-"+numOnly.slice(4,6);
          // this.log("formatStr1 = " + formatStr);
          if(numOnly.length>6){
            formatStr=formatStr+ "-"+numOnly.slice(6,8);
            // this.log("formatStr2 = " + formatStr);
          }
          // this.log("formatStr = " + formatStr);
          let mm = moment(formatStr);
          if (mm.isValid()) {
            let d1 = null;
            if (this.workMode === 'YM') {
              d1 = mm.format('YYYY-MM');
            } else if (this.workMode === 'Y') {
              d1 = mm.format('YYYY');
            } else {
              d1 = mm.format('YYYY-MM-DD');
            }
            // this.log("d1 = " + d1);
            this.inputDate = d1;
          }
        }else if(this.inputDate && this.inputDate.length < 4 && this.workMode === 'Y'){
          let numOnly = this.inputDate.replace(/[^0-9^\.]/g,"");
          let nowYear = getYear(new Date());
          let formatStr = String(nowYear).slice(0, ( this.inputDate.length * -1 ));
          formatStr = formatStr + this.inputDate + "-01-01";
          // this.log("formatStr = " + formatStr);
          let mm = moment(formatStr);
          if (mm.isValid()) {
            let d1 = null;
            if (this.workMode === 'YM') {
              d1 = mm.format('YYYY-MM');
            } else if (this.workMode === 'Y') {
              d1 = mm.format('YYYY');
            } else {
              d1 = mm.format('YYYY-MM-DD');
            }
            // this.log("d1 = " + d1);
            this.inputDate = d1;
          }
        }        // this.log("After InputDate = "+ this.inputDate);
        const parsedDate = parse(this.inputDate, this.dateFormat, new Date());
        if(parsedDate && isValid(parsedDate)){
          return parsedDate;
        }else{
          return null;
        }
      },
      pattern () {
        return this.dateFormat.replace(/yyyy|MM|dd/g, match => {
          switch (match) {
          case 'yyyy':
            return '[0-9]{4}';
          case 'MM':
          case 'dd':
            return '[0-9]{2}';
          }
        })
      }
    },
    watch: {
      inputDate (value) {
        this.inputDateToLocalDate()
      },
      localDate () {
        this.inputDate = this.localString;
        if (this.modelType === Date) {
          this.$emit('input', this.localDate)
        }
      },
      localString () {
        if (this.modelType === String) {
          this.$emit('input', this.localString)
        }
      },
      localNumber () {
        if (this.modelType === Number) {
          this.$emit('input', this.localNumber)
        }
      },
      value: {
        immediate: true,
        handler() {
          this.valueDateToLocalDate()
        }
      },
      mdModelType (type) {
        switch (type) {
        case Date:
          this.$emit('input', this.localDate);
          break;
        case String:
          this.$emit('input', this.localString);
          break;
        case Number:
          this.$emit('input', this.localNumber);
          break;
        }
      },
      dateFormat () {
        if (this.localDate) {
          this.inputDate = format(this.localDate, this.dateFormat)
        }
      }
    },
    methods: {
      toggleDialog () {
        if(this.calendarDisabled || this.attrDisabled){
          return
        }
        if (!isFirefox || this.mdOverrideNative) {
          this.showDialog = !this.showDialog;
          if (this.showDialog) {
            this.$emit('md-opened')
          } else {
            this.$emit('md-closed')
          }
        } else {
          this.$refs.input.$el.click()
        }
      },
      onFocus () {
        if (this.mdOpenOnFocus) {
          this.toggleDialog()
        }
      },
      onValueChange(value){
        this.$emit('on-value-change', value);
      },
      inputDateToLocalDate () {
        if (this.inputDate) {
          if (this.parsedInputDate) {
            this.localDate = this.parsedInputDate;
          }
        } else {
          this.localDate = null
        }
        if(!this.isFirstRun){
          this.isEditFlg = true;
        }
      },
      valueDateToLocalDate () {
        if (this.isModelNull) {
          this.localDate = null
        } else if (this.isModelTypeNumber) {
          this.localDate = new Date( Number(this.value) );
        } else if (this.isModelTypeDate) {
          this.localDate = this.value
        } else if (this.isModelTypeString) {
          let parsedDate = parse(this.value, this.dateFormat, new Date());

          if (isValid(parsedDate)) {
            this.localDate = parse(this.value, this.dateFormat, new Date());
          } else {
            if (this.value.length > 0) {
              Vue.util.warn(`The datepicker value is not a valid date. Given value: ${this.value}, format: ${this.dateFormat}`);
            }
          }
        } else {
          Vue.util.warn(`The datepicker value is not a valid date. Given value: ${this.value}`);
        }

        if(this.isFirstRun){
          let _this=this;
          setTimeout(function () {
            _this.isFirstRun = false;
          },2000);
        }
      },
      log(msg, obj = "") {
        console.log(msg, obj);
      },
      onClear(){
          this.inputDate = "";
      },
    },
    created () {
      this.inputDateToLocalDate = MdDebounce(this.inputDateToLocalDate, this.MdDebounce);
    },
    mounted(){
    },
  }
</script>

<style lang="scss">
  @import "../MdAnimation/variables";
  @import "../MdLayout/mixins";

  .md-datepicker-overlay {
    opacity: 0;

    @include md-layout-xsmall {
      opacity: 1;
    }
  }

  .md-input.error,.md-field.md-theme-default.md-focused label.error{
    color: red;
  }

  .md-field.md-focused label.error, .md-field.md-has-value label.error {
    display: inline-block;
    margin-bottom: 0;
    position: absolute;
    top: 40px;
    left: 0;
    pointer-events: auto;
    opacity: 1;
    font-size: 0.9rem;
  }

  .md-field.md-datepicker.valid{
    border-bottom: 1px solid #00c851;
    box-shadow: 0 1px 0 0 #00c851;
  }

  .md-field.md-theme-default.md-disabled:after {
    background-image: none;
    background-color: rgba(0,0,0,0.2);
  }

  .md-field.md-theme-default:after {
    background-color: #ced4da;
  }

  .md-disabled:after {
    background-color: rgba(0,0,0,0.2) !important;;
    border-color: rgba(0,0,0,0.2) !important;;
  }

  .md-datepicker {
    &.md-native {
      label {
        top: 0 !important;
      }
    }

    &.md-field.md-theme-default > .md-icon::after{
      background-color: transparent;
    }

    .md-date-icon {
      cursor: pointer;
    }

    label.error{
      color: red;
      margin-bottom: 0;
      position: absolute;
      top: initial;
      bottom: -23px;
      left: 0;
      font-size: 0.9rem;
    }

    input[type=date]::-webkit-clear-button,
    input[type=date]::-webkit-inner-spin-button,
    input[type=date]::-webkit-calendar-picker-indicator {
      display: none;
    }

    &.md-field .md-input-action{
          height: 100%;
          top: 0;
      }

    align-items: center;
    padding-top: 0.15rem;
    padding-bottom: 0.15rem;
    margin-top: 0;
    margin-bottom: 0;
    min-height: initial;
  }
</style>
